import { render, staticRenderFns } from "./RatingAverage.vue?vue&type=template&id=794022fe&scoped=true&"
import script from "./RatingAverage.vue?vue&type=script&lang=js&"
export * from "./RatingAverage.vue?vue&type=script&lang=js&"
import style0 from "./RatingAverage.vue?vue&type=style&index=0&id=794022fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794022fe",
  null
  
)

export default component.exports